import { render } from "./ClientIntroduction.vue?vue&type=template&id=754ab394&scoped=true"
import script from "./ClientIntroduction.vue?vue&type=script&lang=js"
export * from "./ClientIntroduction.vue?vue&type=script&lang=js"

import "./ClientIntroduction.vue?vue&type=style&index=0&id=754ab394&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-754ab394"]])

export default __exports__